import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { safeLocalStorage } from "~/utils/safeStorage";
import { popupTypes } from "~/redux/reducers/popupReducer";
import styles from "./index.module.scss";
import Button from "../../../common/button";

// Баннер куки — второй в очереди оверлеев: показываем узкой полосой у нижнего
// края и только когда на экране нет других окон (подтверждение города,
// попапы, мобильное меню, каталог). См. UX-04.
export default function CookieBanner() {
  const [accepted, setAccepted] = useState(true);

  const { isCityConfirmActive, isShowMobileMenu, isShowTopSections } =
    useSelector((state) => state.pageState);
  const { visibleType } = useSelector((state) => state.popup);

  useEffect(() => {
    setAccepted(Boolean(safeLocalStorage.getItem("cookieAccepted")));
  }, []);

  const visible =
    !accepted &&
    !isCityConfirmActive &&
    !isShowMobileMenu &&
    !isShowTopSections &&
    visibleType === popupTypes.none;

  const bannerRef = useRef(null);

  // Полоса не должна закрывать кнопки и карточки — освобождаем место ровно
  // по её высоте: на узких экранах текст переносится и полоса растёт.
  useEffect(() => {
    const { body } = document;
    const clear = () => {
      body.classList.remove("cookieBanner");
      body.style.removeProperty("--cookie-banner-height");
    };

    if (!visible || !bannerRef.current) {
      clear();
      return undefined;
    }

    const banner = bannerRef.current;
    const syncHeight = () => {
      body.style.setProperty(
        "--cookie-banner-height",
        `${Math.ceil(banner.getBoundingClientRect().height)}px`,
      );
    };

    body.classList.add("cookieBanner");
    syncHeight();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", syncHeight);
      return () => {
        window.removeEventListener("resize", syncHeight);
        clear();
      };
    }

    const observer = new ResizeObserver(syncHeight);
    observer.observe(banner);
    return () => {
      observer.disconnect();
      clear();
    };
  }, [visible]);

  const handleAccept = () => {
    safeLocalStorage.setItem("cookieAccepted", "true");
    setAccepted(true);
  };

  if (!visible) return null;

  return (
    <div
      ref={bannerRef}
      className={styles.Body}
      role="region"
      aria-label="Использование куки"
    >
      <span className={styles.Text}>
        Мы используем куки и рекомендательные технологии. Оставаясь на сайте, вы
        соглашаетесь с{" "}
        <a
          className={styles.Link}
          href="/privacy/"
          target="_blank"
          rel="noreferrer"
        >
          политикой обработки персональных данных
        </a>
        .
      </span>
      <Button test="cookieButton" onClick={handleAccept} label={"ОК"}></Button>
    </div>
  );
}
